import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AppBar, Breadcrumbs, Button, CardHeader, Container, Fab, FormControlLabel, IconButton, LinearProgress, Link, RadioGroup, Toolbar, Typography, makeStyles, useMediaQuery, ButtonGroup } from "@material-ui/core";
import { NavigateNext, RemoveShoppingCart, ShoppingBasket } from '@material-ui/icons';
import clsx from 'clsx';
import { localPackageCalculate } from 'pages/CustomerBookingCreate/Cart';
import { BREADCRUMBS, START_STEP, STEP_CART_ENABLED } from 'pages/CustomerBookingCreate/constants';
import { stepState, cartVisibleState, isCartOpenState, bookingState, servicesState, packagesState, DEFAULTLOCATION, bookingRegionState } from 'pages/CustomerBookingCreate/state';
import { Suspense, useEffect, useMemo, useState } from 'react';
import ReactJson from 'react-json-view';
import { useHistory } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { localizeCurrency } from 'util/localizeFormat';
import { useTrackEvent } from 'util/trackEvent';
import { red } from "@material-ui/core/colors";
import { Radio } from "@material-ui/core";
import { CartButton } from './CartButton';
import { RegionSetter } from '../RegionSetter';

const useStyles = makeStyles(theme => ({
  toolbar: {
    paddingBottom: theme.spacing(1),
    marginBottom: "10px",
    borderRadius: 15,
    // boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0",
  },
  title: {
    flexGrow: 1
  },
  cartfab: {
    [theme.breakpoints.down('sm')]: {
      alignSelf: "flex-end",
    }
  },
  crumbs: {
    cursor: "pointer"
  },
  responsiveHeader: {
    display: 'flex',

    // [theme.breakpoints.down('sm')]: {
    //   flexDirection: "column",
    //   alignItems: "flex-start"
    // }
  },
  layoutContainer: {
    // flexGrow: 1,
    // backgroundColor: theme.palette.grey[100],
  }
}));
const PageHeader = ({
  backStep,
  currentStep,
  title,
  subheader,
  isCartEnabled = false,
  showBreadcrumbs = true,
  children,
  loading = false,
  onBackStep = () => { },
  actions = null,
  showLocationSetter = false,
  callToActionButton = null
}) => {
  const classes = useStyles()
  const [step, setStep] = useRecoilState(stepState)


  const [booking, setBooking] = useRecoilState(bookingState);


  const [selectedRegion, setSelectedRegion] = useRecoilState(bookingRegionState);

  const trackEvent = useTrackEvent()
  const history = useHistory()
  const crumbs = useMemo(
    () => {
      const stopIndex = BREADCRUMBS.findIndex((s) => {
        return s?.value === currentStep
      })
      const breadcrumbs = BREADCRUMBS.slice(0, stopIndex).filter((s) => s.visible)?.map((s) => ({ ...s, link: true }))
      if (backStep) {
        breadcrumbs.push({ ...BREADCRUMBS?.[stopIndex], link: false })
      }

      return breadcrumbs

    }, [step, backStep, currentStep, BREADCRUMBS]
  );


  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("xs"),
    {
      noSsr: true,
    });

  return (
    <>

      <AppBar
        className={clsx(isMobile ? null : classes.layoutContainer, classes.toolbar)}
        elevation={0}
        color="default"
        position={isMobile ? 'static' : 'sticky'}
      >
        {step === START_STEP ? null : (
          <Toolbar disableGutters>
            {
              backStep && (
                <IconButton
                  onClick={() => {
                    trackEvent('Create Booking Page Header Arrow Back Clicked', { from: currentStep, to: backStep })
                    setStep(backStep)
                    history.replace(backStep, { internal: true })
                    onBackStep()
                  }}
                  color='primary'>
                  <FontAwesomeIcon icon={faArrowLeft} />
                </IconButton>
              )
            }
            {showBreadcrumbs && (
              <Breadcrumbs
                separator={<NavigateNext fontSize="small" />}
                aria-label="breadcrumb"
                className={classes.crumbs}>
                {crumbs.map((crumb, index) => {
                  return !crumb.link ? (
                    <Typography key={index} color="textPrimary">{crumb?.label}</Typography>
                  ) :
                    (
                      <Link onClick={() => {
                        trackEvent('Create Booking Page Header Breadcrumb Clicked', { from: currentStep, to: crumb.value })
                        setStep(crumb.value)
                        history.replace(crumb.value, { internal: true })
                      }}>
                        {crumb.label}
                      </Link>
                    )
                }
                )}
              </Breadcrumbs>
            )}
          </Toolbar>
        )}
        <Toolbar variant="dense" disableGutters className={classes.responsiveHeader}>
          <CardHeader className={classes.title}
            title={title}
            subheader={
              subheader
            }
          />
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              flex: '0 0 auto'
            }}
          >
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'auto',
                gap: '.5rem',
              }}
            >
              {
                showLocationSetter && <RegionSetter />
              }
              {actions && actions()}
              {!isMobile && (
                <Suspense fallback={<Button variant="contained" disabled fullWidth>Loading...</Button>}>
                <CartButton
                  isCartEnabled={isCartEnabled}
                />
                </Suspense>
              )}
            </div>
          </div>


        </Toolbar>
      </AppBar>
      <div className={classes.layoutContainer}>
        {loading ? <LinearProgress /> : children}
      </div>
      {isMobile ? (
        <AppBar elevation={0} style={{
          position: 'fixed',
          top: 'auto',
          bottom: 0,
          right: 0,
          backgroundColor: 'transparent',
          
        }}>
          <Toolbar style={{
            justifyContent: 'space-between'

          }}>
            <div
              style={{
                width: 60,
                height: 70
              }}
            >
            </div>
            {callToActionButton}
          </Toolbar>
        </AppBar>
      ): callToActionButton}
    </>
  )
}

export { PageHeader };
